/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */

var Model = require("../types/Model.js");
var xtend = require("xtend");

module.exports = new Model({
	name: "machinestatelogger",
	listeners: listeners,

	_reconnecting: false,
	_bluetooth: false,
	_finding: null,
	_scanning: false,
});

function listeners() {
	return {
		"bluetooth:scanned": handleScanned,
		"bluetooth:error": handleBluetoothError,
		"bluetoothonoff:updated": handleBluetoothChange,
		"braceletfinder:updated": handleFinderChange,
		"braceletreconnector:updated": handleReconnecting,
		"braceletreconnector:taking": handleTaking,
		"braceletreconnector:ignored": handleIgnored,
		"buzz:error": handleBuzzError
	};
}

function handleBuzzError(error) {
	this.emit("machineevents:trigger:state:calling:error", error);
}

function handleBluetoothError(error) {
	if(error.message)
		error = xtend(error, {
			message: error.message
		});

	this.emit("machineevents:trigger:state:bluetooth:error", error);
}

function handleTaking(data) {
	this.emit("machineevents:trigger:state:take", data);
}

function handleReconnecting(reconnecting) {
	if (reconnecting === this._reconnecting)
		return;

	this._reconnecting = reconnecting;
	this.emit("machineevents:trigger:state:reconnecting", {
		reconnecting: reconnecting
	});
}

function handleScanned(device) {
	this.emit("machineevents:trigger:state:scanned", device);
}

function handleBluetoothChange(bluetooth) {
	if (bluetooth === this._bluetooth)
		return;

	this._bluetooth = bluetooth;
	this.emit("machineevents:trigger:state:bluetooth", {
		on: bluetooth
	});
}

function handleFinderChange(finding) {
	if (this._finding && finding.length === this._finding.length)
		return;

	this._finding = finding;
	this.emit("machineevents:trigger:state:finding", {
		list: finding
	});
}

function handleIgnored(data) {
	this.emit("machineevents:trigger:state:ignored", data);
}
